import React from "react";
import { EMPTY_STRING } from "../../constants/Dictionary";
import { BodyTyp } from "../Typography/Typography";
import { theme } from "../../constants/StyledComponents";
import { FontWeightEnum } from "../../types/AppTypes";
import { StyledTextAreaBox } from "./TextAreaBox.styled";

export type TextAreaBoxProps = {
  text?: string | React.ReactNode | null;
  variant?: string;
  fontWeight?: FontWeightEnum;
  color?: string;
  noTranslate?: boolean;
  error?: boolean;
};

export const TextAreaBox = ({
  text,
  variant = "2",
  fontWeight = FontWeightEnum.MEDIUM,
  color,
  noTranslate,
  error,
}: TextAreaBoxProps) => {
  return (
    <StyledTextAreaBox>
      <BodyTyp
        variant={variant}
        fontWeight={fontWeight}
        noTranslate={noTranslate}
        color={error ? theme.colors.red_1 : color}
      >
        {text || EMPTY_STRING}
      </BodyTyp>
    </StyledTextAreaBox>
  );
};
